/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import ResourceBundle from "sap/base/i18n/ResourceBundle";

export default ResourceBundle.create({
    bundleName: "sap.esh.search.ui.resources.resources",
}) as ResourceBundle;
